import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Field, PowerSelect } from '@itds/elements/index.js';

const General = ({ relationship, saveRelationship }) => {
  const [whitelisted_hosts, setWhitelistedHosts] = useState(relationship.whitelisted_hosts);

  const handleSelectChange = new_selected => {
    setWhitelistedHosts(new_selected.map(s => s.value));
  };

  const handleSave = () => {
    saveRelationship({ whitelisted_hosts });
  };

  return (
    <>
      <Field
        description="Enter the domains and/or IP addresses that are allowed access to the API endpoints for this Partner. This helps to ensure that the Partner's credentials aren’t used by unauthorized parties."
        label='Whitelisted Hosts'
      >
        <PowerSelect
          creatable={true}
          isMulti={true}
          noOptionsMessage='Start typing...'
          onChange={handleSelectChange}
          placeholder='Enter domains and ip addresses...'
          value={whitelisted_hosts.map(wh => ({ value: wh, label: wh }))}
        />
      </Field>

      <div style={{ marginTop: 30 }}>
        <Button inline={true} onClick={handleSave}>
          Save Changes
        </Button>
      </div>
    </>
  );
};

General.propTypes = {
  relationship: PropTypes.object,
  saveRelationship: PropTypes.func
};

export default General;
